import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[appLegacy]'
})
export class LegacyDirective {

  constructor(element: ElementRef) {
    element.nativeElement.style.color = '#2196F3';
    element.nativeElement.style.fontWeight = 'bold';
  }

}
